import { render, staticRenderFns } from "./remote-control-button.vue?vue&type=template&id=0fc7e032&"
import script from "./remote-control-button.vue?vue&type=script&lang=ts&"
export * from "./remote-control-button.vue?vue&type=script&lang=ts&"
import style0 from "./remote-control-button.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports